<!-- @format -->

<span>
  <sis-icon icon="required"></sis-icon>
  {{ "FORM.REQUIRED_FIELD_LEGEND" | translate }}
</span>
